// ESC/POS Commands
const ESC = 0x1B;
const GS = 0x1D;

const CMD_INIT = [ESC, 0x40];
const CMD_ALIGN_LEFT = [ESC, 0x61, 0x00];
const CMD_ALIGN_CENTER = [ESC, 0x61, 0x01];
const CMD_FONT_NORMAL = [ESC, 0x4D, 0x00];     // Font A
const CMD_FONT_COMPRESSED = [ESC, 0x4D, 0x01]; // Font B
const CMD_FEED_CUT = [ESC, 0x64, 0x05];         // Feed 5 lines

// Barcode settings
const CMD_BARCODE_WIDTH = [GS, 0x77, 0x02];    // Width 2
const CMD_BARCODE_HEIGHT = [GS, 0x68, 0x3C];   // Height 60
const CMD_BARCODE_TXT_POS = [GS, 0x48, 0x02];  // HRI below barcode

function stringToBytes(str: string): number[] {
  const bytes: number[] = [];
  for (let i = 0; i < str.length; i++) {
    const code = str.charCodeAt(i);
    bytes.push(code < 128 ? code : 0x3F);
  }
  return bytes;
}

function padString(str: string, length: number, align: 'left' | 'right' | 'center' = 'left'): string {
  if (str.length >= length) {
    return str.substring(0, length);
  }
  const spaces = ' '.repeat(length - str.length);
  if (align === 'right') {
    return spaces + str;
  }
  if (align === 'center') {
    const half = Math.floor(spaces.length / 2);
    return spaces.slice(0, half) + str + spaces.slice(half);
  }
  return str + spaces;
}

export function compileTejVoucher(voucher: {
  storeName: string;
  tokenCode: string;
  creditAmount: number;
  customerName: string;
  expiryDate: string;
}): Uint8Array {
  const bytes: number[] = [];

  // 1. Init
  bytes.push(...CMD_INIT);
  bytes.push(...CMD_FONT_COMPRESSED);

  // 2. Bold Store Name Header
  bytes.push(...CMD_ALIGN_CENTER);
  bytes.push(...stringToBytes(padString(voucher.storeName.toUpperCase(), 32, 'center') + '\n'));
  bytes.push(...stringToBytes(padString('EXCHANGE CREDIT SLIP', 32, 'center') + '\n'));
  bytes.push(...stringToBytes('--------------------------------\n'));

  // 3. Bold Exchange Amount Header
  bytes.push(...CMD_FONT_NORMAL); // Switch to normal font for double emphasis
  bytes.push(...stringToBytes(`CREDIT VALUE:\n`));
  bytes.push(...stringToBytes(`Rs. ${voucher.creditAmount.toFixed(2)}\n`));
  bytes.push(...CMD_FONT_COMPRESSED); // Switch back
  bytes.push(...stringToBytes('--------------------------------\n'));

  // 4. Token Details
  bytes.push(...CMD_ALIGN_LEFT);
  bytes.push(...stringToBytes(`TOKEN CODE: ${voucher.tokenCode}\n`));
  bytes.push(...stringToBytes(`CUSTOMER  : ${voucher.customerName}\n`));
  bytes.push(...stringToBytes(`EXPIRY    : ${voucher.expiryDate}\n`));
  bytes.push(...stringToBytes('--------------------------------\n'));

  // 5. Scannable Barcode Command
  bytes.push(...CMD_ALIGN_CENTER);
  bytes.push(...CMD_BARCODE_WIDTH);
  bytes.push(...CMD_BARCODE_HEIGHT);
  bytes.push(...CMD_BARCODE_TXT_POS);
  // Code 39 system in ESC/POS: m = 4, followed by characters, terminated by 0x00
  bytes.push(GS, 0x6B, 0x04);
  bytes.push(...stringToBytes(voucher.tokenCode));
  bytes.push(0x00);
  bytes.push(0x0A); // linefeed

  bytes.push(...stringToBytes('\n* Present at checkout for *\n'));
  bytes.push(...stringToBytes('* dynamic token redemption *\n'));
  bytes.push(...CMD_ALIGN_LEFT);

  // 6. Cut
  bytes.push(...CMD_FEED_CUT);

  return new Uint8Array(bytes);
}
